const s = {
  name: "Okta",
  dimensions: { width: 40, height: 34 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 34" style="enable-background:new 0 0 40 34;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M3,4c0-2.2,1.8-4,4-4h2v2H7C5.9,2,5,2.9,5,4v10c0,1.2-0.5,2.3-1.4,3C4.5,17.7,5,18.8,5,20v10c0,1.1,0.9,2,2,2
			h2v2H7c-2.2,0-4-1.8-4-4V20c0-1.1-0.9-2-2-2H0v-2h1c1.1,0,2-0.9,2-2V4z"/>
		<path class="st0" d="M20,11c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S23.3,11,20,11z M16,17c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4
			S16,19.2,16,17z"/>
		<path class="st0" d="M20,5C13.4,5,8,10.4,8,17s5.4,12,12,12s12-5.4,12-12S26.6,5,20,5z M10,17c0-5.5,4.5-10,10-10s10,4.5,10,10
			s-4.5,10-10,10S10,22.5,10,17z"/>
		<path class="st0" d="M39,18c-1.1,0-2,0.9-2,2v10c0,2.2-1.8,4-4,4h-2v-2h2c1.1,0,2-0.9,2-2V20c0-1.2,0.5-2.3,1.4-3
			c-0.8-0.7-1.4-1.8-1.4-3V4c0-1.1-0.9-2-2-2h-2V0h2c2.2,0,4,1.8,4,4v10c0,1.1,0.9,2,2,2h1v2H39z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Okta
};
